import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MainPage from './MainPage';
import PhonePage from './PhonePage';
import EmailPage from './EmailPage';

export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={MainPage} />
    <Route exact path={`${match.url}/phone`} component={PhonePage} />
    <Route exact path={`${match.url}/email`} component={EmailPage} />
  </Switch>
);
